import { connect } from 'react-redux';

import { IApplicationState } from '@store';
import { logOut } from '@store/actions';
import { AuthenticationStatus } from '@store/types';

import Header, {
  IHeaderDispatchProps,
  IHeaderStateProps,
} from '../components/header/Header';
import _ from 'lodash';
import { IAccountProject } from '@models/accounts';

interface IStateToProps
  extends Pick<IApplicationState, 'authentication' | 'projectPicker'> {}

const mapStateToProps = ({
  authentication,
  projectPicker,
}: IStateToProps): IHeaderStateProps => {
  let activeProject = _.find(
    projectPicker.projectsList,
    (project: IAccountProject) =>
      project.projectId === projectPicker.activeProjectId
  );

  return {
    isAuthenticated:
      authentication.status === AuthenticationStatus.authenticated,
    email: authentication.user ? authentication.user.email : undefined,
    brandImage:
      activeProject && activeProject.customProperties
        ? activeProject.customProperties.brandImage
        : undefined,
  };
};

const mapDispatchToProps = (dispatch: any): IHeaderDispatchProps => ({
  logOut: () => dispatch(logOut()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
